import { render, staticRenderFns } from "./SsoLoginWrapper.vue?vue&type=template&id=de3b52b0&"
import script from "./SsoLoginWrapper.vue?vue&type=script&lang=js&"
export * from "./SsoLoginWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports